/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { string as codecString } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseAccessPlanData } from './BaseAccessPlanData';
const CreateAccessPlanDataParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([['tenantId', codecString, 'tenant_id']]), BaseAccessPlanData);
export class CreateAccessPlanData extends BaseAccessPlanData {
    static decode(input) {
        return CreateAccessPlanDataParser.decode(input).map(res => new CreateAccessPlanData(res));
    }
    static unsafeDecode(input) {
        return CreateAccessPlanData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CreateAccessPlanDataParser.encode(data);
    }
    static schema() {
        return CreateAccessPlanDataParser.schema();
    }
}
